import { render } from "./selectBusStop.vue?vue&type=template&id=244c4870&scoped=true"
import script from "./selectBusStop.vue?vue&type=script&lang=js"
export * from "./selectBusStop.vue?vue&type=script&lang=js"

import "./selectBusStop.vue?vue&type=style&index=0&id=244c4870&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-244c4870"

export default script